import template from './comment-section.pug';
import controller from './comment-section.controller';

const CommentSectionComponent = {
  template,
  controller,
  bindings: {
    case: '<',
  },
};

export default CommentSectionComponent;



// WEBPACK FOOTER //
// ./client/components/comment-section/comment-section.component.js